import { atom } from 'jotai';

export const plateIdAtom = atom<string | null>(null);
